import type { Supabase } from '@firmable/contracts';
import { ObjectHelper } from '../../ObjectHelper';

/**
 * Record (not a plain array) so adding a key to WhoYouSellTo without updating this
 * set is a compile error — keeps the identifier list exhaustive.
 */
const WHO_YOU_SELL_TO_SET: Record<keyof Supabase.User.WhoYouSellTo, true> = {
  position: true,
  department: true,
  seniority: true,
};

export const Icp = {
  /** The people filters that make up who-you-sell-to; anything else AI search predicts is dropped. */
  WHO_YOU_SELL_TO_IDENTIFIERS: ObjectHelper.getKeys(WHO_YOU_SELL_TO_SET),
};
